import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap';
import { FiPlus, FiMoreHorizontal } from "react-icons/fi";
import moment from 'moment';
import EmployeeContractEdit from "./EmployeeContractEditModal";
import ContractEditDrawer from "../Contracts/ContractEditDrawer";
import DataTable from "components/DataTable";
import { showModal, hideModal } from "actions/modalActions";
import * as employeesActions from 'actions/employeesActions';
import { employeesService } from "services";
import { errorFormating, isAdmin } from "utils/utils";

class EmployeeContracts extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.getContracts = this.getContracts.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openNewEmployeeContractModal = this.openNewEmployeeContractModal.bind(this);
		this.openEditEmployeeContractModal = this.openEditEmployeeContractModal.bind(this);
		this.openEditContractModal = this.openEditContractModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
	}

	async componentDidMount() {
		await this.getContracts();
		this.openRequestedAssignment();
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.openAssignment && this.props.openAssignment) {
			this.openRequestedAssignment();
		}
	}

	openRequestedAssignment = () => {
		if (!this.props.openAssignment) return;

		this.openNewEmployeeContractModal();
		if (typeof this.props.onAssignmentRequestHandled === "function") {
			this.props.onAssignmentRequestHandled();
		}
	};

	async getContracts() {
		const employeeId = this.props.employee.id;
		await this.props.getEmployeeContracts(employeeId);
	}

	closeModal() {
		this.props.hideModal()
	}

	openNewEmployeeContractModal() {
		const { contracts, employee } = this.props;

		this.props.showModal({
			open: true,
			title: this.props.t('contracts.assignment.assignContract'),
			style: { width: '350px' },
			content: (
				<EmployeeContractEdit
					handleClose={this.closeModal}
					contracts={contracts}
					employee={employee}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
	}

	openEditEmployeeContractModal(employee_contract) {
		const { contracts, employee } = this.props;

		this.props.showModal({
			open: true,
			title: this.props.t('contracts.assignment.editAssignment'),
			style: { width: '350px' },
			content: (
				<EmployeeContractEdit
					employee_contract={employee_contract}
					employee={employee}
					handleClose={this.closeModal}
					contracts={contracts}
					onDataChanged={this.props.onDataChanged}
				/>
			),
			closeModal: this.closeModal
		}, 'edit')
	}

	openEditContractModal(employee_contract) {
		this.props.showModal({
			open: true,
			width: 1000,
			content: ({ close, registerBeforeClose }) => (
				<ContractEditDrawer
					contract={employee_contract.contract}
					getContracts={this.getContracts}
					handleClose={close}
					registerBeforeClose={registerBeforeClose}
				/>
			),
			closeModal: this.closeModal
		}, 'drawer')
	}

	openDeleteEmployeeContractModal(idContract) {
		this.props.showModal({
			open: true,
			title: this.props.t('contracts.assignment.deleteAssignment'),
			style: { width: '350px' },
			message: this.props.t('contracts.assignment.deleteConfirmation'),
			deleteAction: () => this.confirmDelete(idContract),
			closeModal: this.closeModal
		}, 'delete')
	}

	openAlertModal(message) {
		this.props.showModal({
			open: true,
			title: this.props.t("contracts.assignment.deleteError"),
			style: { width: '400px' },
			message: message,
			closeModal: this.closeModal
		}, 'alert')
	}

	confirmDelete = async (idContract) => {
		const response = await employeesService.removeContract(this.props.employee.id, idContract);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				textError.general || textError.id || this.props.t('contracts.assignment.deleteError')
			);
		}
		else {
			this.getContracts();
			if (typeof this.props.onDataChanged === "function") {
				this.props.onDataChanged();
			}
			this.closeModal();
		}
	}

	getColumns = () => [
		{
			key: "contract",
			header: this.props.t("contracts.assignment.headerContract"),
			sortAccessor: (row) => row.contract?.name || "",
			render: (row) => (
				<button className="btn-transparent btn-editable" onClick={() => this.openEditEmployeeContractModal(row)}>
					{row.contract.name}
				</button>
			),
		},
		{
			key: "start_day",
			header: this.props.t("contracts.assignment.headerStart"),
			render: (row) => moment(row.start_day).format("DD/MM/YY"),
		},
		{
			key: "end_day",
			header: this.props.t("contracts.assignment.headerEnd"),
			render: (row) => row.end_day ? moment(row.end_day).format("DD/MM/YY") : "-",
		},
	];

	renderActions = (employee_contract) => (
		<Dropdown>
			<Dropdown.Toggle variant="action"><FiMoreHorizontal /></Dropdown.Toggle>
			<Dropdown.Menu>
				<Dropdown.Item as="button" onClick={() => this.openEditEmployeeContractModal(employee_contract)}>{this.props.t('contracts.assignment.editAssignmentAction')}</Dropdown.Item>
				{isAdmin() && (
					<Dropdown.Item as="button" onClick={() => this.openEditContractModal(employee_contract)}>{this.props.t('contracts.assignment.editContract')}</Dropdown.Item>
				)}
				<Dropdown.Item as="button" onClick={() => this.openDeleteEmployeeContractModal(employee_contract.id)}>{this.props.t('common.delete')}</Dropdown.Item>
			</Dropdown.Menu>
		</Dropdown>
	);

	getContent = () => {
		const { employee_contracts } = this.props;

		return (
			<div className="employee-profile-datatable-wrap">
				<DataTable
					tableClassName="table-groups table-employee-contracts table-hover"
					columns={this.getColumns()}
					rows={employee_contracts}
					rowKey={(row) => row.id}
					emptyMessage={this.props.t('contracts.assignment.noContractsAssigned')}
					actionsColumn={{
						render: this.renderActions,
						className: "td-actions",
						header: <button type="button" title={this.props.t("contracts.assignment.assignContract")} onClick={this.openNewEmployeeContractModal} className="btn btn-new"><FiPlus /></button>,
					}}
				/>
			</div>
		);
	}
	render() {
		return (
			<>
				{this.getContent()}
			</>
		)
	}
}


const mapStateToProps = state => {
	return {
		employee_contracts: state.employeesReducer.employee_contracts,
		user: state.authReducer.user,
	}
}

const mapDispatchToProps = dispatch => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }))
	},
	getEmployeeContracts: (id) => dispatch(employeesActions.getEmployeeContracts(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmployeeContracts));
